import styled from 'styled-components';

export const ImageBannerContainer = styled.div`
  max-width: 128rem;
  margin: 0 auto;
`;
